import { render, staticRenderFns } from "./Provide-Skill-Feedback.vue?vue&type=template&id=4190ef54&"
import script from "./Provide-Skill-Feedback.vue?vue&type=script&lang=js&"
export * from "./Provide-Skill-Feedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports